<template>
  <div class="fill-height of-y pa-2">
    <v-card class="fill-height of-y">
      <v-card-title class="text-h6 title-color white--text" style="position: sticky; top: 0; z-index: 9">
        {{ editChannel.internalName }}
      </v-card-title>
      
      <v-card-text>
        
        <v-form ref="editChannelForm" @submit="$event.preventDefault()" v-model="valid">
          <v-text-field
              label="Internal Name"
              color="primary"
              style="width: 100%"
              v-model="channel.internalName"
              :disabled="savingChanges"
              :autofocus="true"
              :rules="[validationRules.required]"
          />
          
          <v-text-field
              label="External Name"
              color="primary"
              style="width: 100%"
              v-model="channel.externalName"
              :disabled="savingChanges"
              :autofocus="true"
              :rules="[validationRules.required]"
          />
          
          <v-autocomplete
              label="Limit to apps"
              placeholder="Available for all apps"
              :persistent-placeholder="true"
              :items="apps"
              item-value="id"
              item-text="name"
              color="primary"
              style="width: 100%"
              v-model="channel.fkApps"
              multiple
              chips
              small-chips
              deletable-chips
              :disabled="savingChanges"
          />
          
          <v-autocomplete
              label="Linked Folder Groups"
              placeholder="Public Channel"
              :persistent-placeholder="true"
              :items="[...folderGroups].sort((a,b) => a.description > b.description ? 1 : -1)"
              item-value="id"
              item-text="description"
              color="primary"
              style="width: 100%"
              v-model="channel.fkFolderGroups"
              multiple
              chips
              small-chips
              deletable-chips
              :disabled="savingChanges"
          />
          
          <v-autocomplete
              v-if="Array.isArray(channel.fkFolderGroups) && channel.fkFolderGroups.length"
              label="User Groups"
              :persistent-placeholder="true"
              :items="availableUserGroups"
              item-value="id"
              item-text="description"
              color="primary"
              style="width: 100%"
              v-model="channel.fkUserGroups"
              multiple
              chips
              small-chips
              deletable-chips
              :disabled="savingChanges"
              :rules="[validationRules.required, (v) => !!(Array.isArray(v) && v.length) || 'At least one user group is required']"
          />
          
          <v-autocomplete
              label="Channel color"
              :items="channelColors"
              item-value="value"
              item-text="name"
              color="primary"
              style="width: 100%"
              :value="channelColors.find(color => color.value === channel.color) ? channel.color : '#FFF'"
              @input="channel.color = $event"
              :disabled="savingChanges"
          >
            
            <template #item="{item, props}">
                <v-list-tile-avatar>
                  <div style="width: 32px; height: 32px; border-radius: 16px" :style="`background: ${item.value || '#a2a2a2'}`">
                  </div>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title v-text="item.name"></v-list-tile-title>
                </v-list-tile-content>
            </template>
            
            <template #selection="{item, props}">
              <v-list-tile-avatar>
                <div style="width: 32px; height: 32px; border-radius: 16px" :style="`background: ${channel.color || '#a2a2a2'}`">
                </div>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title v-text="item.name"></v-list-tile-title>
              </v-list-tile-content>
            </template>
            
          </v-autocomplete>
          
          <v-text-field
              v-if="!channelColors.map(val => val.value).includes(channel.color) || channel.color === '#FFF'"
              label="Custom Color"
              color="primary"
              style="width: 100%"
              v-model="channel.color"
              :disabled="savingChanges"
              :autofocus="true"
              :rules="[validationRules.required]"
          />
          
          <icon-input
              v-model="channel.icon"
              :persistent-placeholder="true"
              placeholder="Default"
          ></icon-input>
          
          
          <div class="pt-4 input-box">
            <div class="v-label v-label--active master-title" :class="$store.state.darkTheme ? 'theme--dark' : 'theme-light'" style="font-size: 10.5px">Channel Active Hours (Leave 00:00 - 00:00) for all day</div>
            
            <div class="c-d-flex c-align-baseline c-justify-space-around" v-for="(cfg, i) in channel.activeHoursConfigDefault">
              
              <div style="width: 300px">
                {{daysRef[i]}}
              </div>
              
              <v-autocomplete
                  label="Start Time"
                  :items="timesList"
                  item-value="value"
                  item-text="text"
                  color="primary"
                  style="max-width: 150px"
                  v-model.number="cfg[0]"
                  @input="$refs.editChannelForm.validate()"
                  :disabled="savingChanges"
                  :rules="[
                      (v) => v <= cfg[1] || 'Start can not be before end'
                  ]"
              >
              </v-autocomplete>
              
              <v-autocomplete
                  label="End Time"
                  :items="timesList"
                  item-value="value"
                  item-text="text"
                  color="primary"
                  style="max-width: 150px"
                  v-model.number="cfg[1]"
                  @input="$refs.editChannelForm.validate()"
                  :disabled="savingChanges"
                  :rules="[
                      (v) => v >= cfg[0] || 'End can not be before start'
                  ]"
              >
              </v-autocomplete>
            
            </div>
          
          </div>
          
          <v-textarea
              auto-grow
              rows="3"
              label="After hours message"
              color="primary"
              style="width: 100%"
              v-model="channel.afterHoursMessage"
              :disabled="savingChanges"
              :autofocus="true"
              :rules="[validationRules.required]"
          />
          
          <v-switch
              class="pt-2"
              label="Disable Channel"
              v-model="channel.disabled"
              color="primary"
              hide-details
              :disabled="savingChanges"
          />
          
        </v-form>
        
        
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn
            flat
            @click="resetField"
            :disabled="savingChanges"
        >Cancel</v-btn>
<!--        @click="saveChanges"-->
        <v-btn
            @click="saveChanges"
            color="secondary"
            :disabled="savingChanges || !valid"
            :loading="savingChanges"
        >Save Changes</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>

import {arrSplice, validationRules} from "@/codeFunctions";
import IconInput from "@/components/General/IconInput/IconInput.vue";
import format from "date-fns/format";

const timesList = [{"text": "00:00", "value": 0}, {"text": "00:15", "value": 900000}, {"text": "00:30", "value": 1800000}, {"text": "00:45", "value": 2700000}, {"text": "01:00", "value": 3600000}, {"text": "01:15", "value": 4500000}, {"text": "01:30", "value": 5400000}, {"text": "01:45", "value": 6300000}, {"text": "02:00", "value": 7200000}, {"text": "02:15", "value": 8100000}, {"text": "02:30", "value": 9000000}, {"text": "02:45", "value": 9900000}, {"text": "03:00", "value": 10800000}, {"text": "03:15", "value": 11700000}, {"text": "03:30", "value": 12600000}, {"text": "03:45", "value": 13500000}, {"text": "04:00", "value": 14400000}, {"text": "04:15", "value": 15300000}, {"text": "04:30", "value": 16200000}, {"text": "04:45", "value": 17100000}, {"text": "05:00", "value": 18000000}, {"text": "05:15", "value": 18900000}, {"text": "05:30", "value": 19800000}, {"text": "05:45", "value": 20700000}, {"text": "06:00", "value": 21600000}, {"text": "06:15", "value": 22500000}, {"text": "06:30", "value": 23400000}, {"text": "06:45", "value": 24300000}, {"text": "07:00", "value": 25200000}, {"text": "07:15", "value": 26100000}, {"text": "07:30", "value": 27000000}, {"text": "07:45", "value": 27900000}, {"text": "08:00", "value": 28800000}, {"text": "08:15", "value": 29700000}, {"text": "08:30", "value": 30600000}, {"text": "08:45", "value": 31500000}, {"text": "09:00", "value": 32400000}, {"text": "09:15", "value": 33300000}, {"text": "09:30", "value": 34200000}, {"text": "09:45", "value": 35100000}, {"text": "10:00", "value": 36000000}, {"text": "10:15", "value": 36900000}, {"text": "10:30", "value": 37800000}, {"text": "10:45", "value": 38700000}, {"text": "11:00", "value": 39600000}, {"text": "11:15", "value": 40500000}, {"text": "11:30", "value": 41400000}, {"text": "11:45", "value": 42300000}, {"text": "12:00", "value": 43200000}, {"text": "12:15", "value": 44100000}, {"text": "12:30", "value": 45000000}, {"text": "12:45", "value": 45900000}, {"text": "13:00", "value": 46800000}, {"text": "13:15", "value": 47700000}, {"text": "13:30", "value": 48600000}, {"text": "13:45", "value": 49500000}, {"text": "14:00", "value": 50400000}, {"text": "14:15", "value": 51300000}, {"text": "14:30", "value": 52200000}, {"text": "14:45", "value": 53100000}, {"text": "15:00", "value": 54000000}, {"text": "15:15", "value": 54900000}, {"text": "15:30", "value": 55800000}, {"text": "15:45", "value": 56700000}, {"text": "16:00", "value": 57600000}, {"text": "16:15", "value": 58500000}, {"text": "16:30", "value": 59400000}, {"text": "16:45", "value": 60300000}, {"text": "17:00", "value": 61200000}, {"text": "17:15", "value": 62100000}, {"text": "17:30", "value": 63000000}, {"text": "17:45", "value": 63900000}, {"text": "18:00", "value": 64800000}, {"text": "18:15", "value": 65700000}, {"text": "18:30", "value": 66600000}, {"text": "18:45", "value": 67500000}, {"text": "19:00", "value": 68400000}, {"text": "19:15", "value": 69300000}, {"text": "19:30", "value": 70200000}, {"text": "19:45", "value": 71100000}, {"text": "20:00", "value": 72000000}, {"text": "20:15", "value": 72900000}, {"text": "20:30", "value": 73800000}, {"text": "20:45", "value": 74700000}, {"text": "21:00", "value": 75600000}, {"text": "21:15", "value": 76500000}, {"text": "21:30", "value": 77400000}, {"text": "21:45", "value": 78300000}, {"text": "22:00", "value": 79200000}, {"text": "22:15", "value": 80100000}, {"text": "22:30", "value": 81000000}, {"text": "22:45", "value": 81900000}, {"text": "23:00", "value": 82800000}, {"text": "23:15", "value": 83700000}, {"text": "23:30", "value": 84600000}, {"text": "23:45", "value": 85500000}]

const daysRef = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']

const blankChannel = {
  id: null,
  internalName: null,
  externalName: null,
  fkFolderGroups: [],
  fkUserGroups: [],
  fkApps: [],
  color: null,
  icon: null,
  disabled: false,
  activeHoursConfigDefault: [[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],
  afterHoursMessage: null,
}

const channelColors = [
  {name: 'Auto', value: null},
  {name: 'Custom', value: '#FFF'},
  {name: 'Red', value: '#F44336'},
  {name: 'Pink', value: '#E91E63'},
  {name: 'Purple', value: '#9C27B0'},
  {name: 'Deep Purple', value: '#673AB7'},
  {name: 'Indigo', value: '#3F51B5'},
  {name: 'Blue', value: '#2196F3'},
  {name: 'Light Blue', value: '#03A9F4'},
  {name: 'Cyan', value: '#00BCD4'},
  {name: 'Teal', value: '#009688'},
  {name: 'Green', value: '#4CAF50'},
  {name: 'Light Green', value: '#8BC34A'},
  {name: 'Lime', value: '#CDDC39'},
  {name: 'Yellow', value: '#FFEB3B'},
  {name: 'Amber', value: '#FFC107'},
  {name: 'Orange', value: '#FF9800'},
  {name: 'Deep Orange', value: '#FF5722'},
  {name: 'Brown', value: '#795548'},
]

export default {
  components: {IconInput},
  props: {
    editChannel: {
      type: Object,
      default: () => []
    },
    folderGroups: Array,
    userGroups: Array,
    apps: Array,
    
  },
  data() {
    return {
      editTypes: [
        {id: 1, description: 'Open'},
        {id: 2, description: 'Contact Only'},
        {id: 3, description: 'Tasklogix Only'},
      ],
      
      channel: blankChannel,
      savingChanges: false,
      valid: false,
      channelColors,
      timesList,
      daysRef
    }
  },
  watch: {
    editChannel: {
      immediate: true,
      handler(val) {
        this.resetField()
      }
    }
  },
  methods: {
    format,
    // updateLookup(val) {
    //   const selectedLookup = this.fieldTypes.find(fieldType => fieldType.id === val).defaultLookup || {}
    //   const newLookup = JSON.parse(JSON.stringify(selectedLookup))
    //   this.channel.lookup = Object.assign(newLookup, this.channel.lookup)
    // },
    
    resetField() {
      console.log(this.editChannel)
      this.channel = JSON.parse(JSON.stringify(this.editChannel))
    },
    async saveChanges() {

      if (!this.$refs.editChannelForm.validate())
        return this.$snack.error('Error Required Fields Missing')

      try {
        this.savingChanges = true
        const savedValue = await this.$newReq('POST', `channels/setup/update`, this.channel)
        this.$emit('input', savedValue)
        this.$snack.info('Changes Saved')
      } catch (e) {
        console.log(e)
        this.$snack.networkError()
      } finally {
        this.savingChanges = false
      }

    },
  
  },
  computed: {
    validationRules() {
      return validationRules
    },
    
    availableUserGroups() {
      const allowedUserGroups = this.folderGroups
          .filter(fg => this.channel.fkFolderGroups.includes(fg.id))
          .map(v => v.userGroups)
          .flat()
      
      return this.userGroups
          .map(v => {
            return {
              ...v,
              disabled: !allowedUserGroups.includes(v.id)
            }
          })
          .sort((a, b) => {
            if (a.disabled === b.disabled)
              return a.description > b.description ? 1 : -1
            return a.disabled ? 1 : -1
          })
      
      
    }
    // visibleSwitch: {
    //   get() {
    //     return !!this.channel.visible
    //   },
    //   set(val) {
    //     this.channel.visible = val ? 1 : 0
    //   }
    // }
  },
}
</script>



<style scoped>
.input-box:hover .master-title,
.input-box:focus-within .master-title {
//font-weight: bold;
  color: var(--v-primary-base);
}
</style>